import React from 'react';
import { withStyles } from 'tss-react/mui';
import AbstractDialogTab from '../../../base/dialog/components/web/AbstractDialogTab';
import { translate } from '../../../base/i18n/functions';
import Checkbox from '../../../base/ui/components/web/Checkbox';
const styles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            paddingBottom: '8px',
        },
        checkboxContainer: {
            position: 'absolute',
            bottom: 0,
            backgroundColor: 'rgba(33, 33, 33, 1)',
            left: '2px',
            borderRadius: '0px 0px 7px 0px',
            width: 'calc(100% - 2px)',
        },
        checkbox: {
            padding: '16px 22px',
        },
        checkboxText: {
            lineHeight: '18px',
        },
        listContainer: {
            listStyleType: 'none',
            padding: 0,
            margin: 0
        },
        listItem: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            padding: 0,
            fontFamily: 'Lato Regular',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '18px',
            color: 'rgba(255, 255, 255, 0.75)',
            gap: '12px',
            marginTop: '7px',
            '&:first-child': {
                marginTop: 0,
            }
        },
        listItemKey: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            fontFamily: 'Lato SemiBold',
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '22px',
            padding: '0px 4px',
            borderRadius: '4px',
            minWidth: '16px',
            height: '23px',
            textAlign: 'center',
        }
    };
};
/**
 * React {@code Component} for modifying the local user's profile.
 *
 * @augments Component
 */
class ShortcutsTab extends AbstractDialogTab {
    /**
     * Initializes a new {@code MoreTab} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handler so it is only bound once for every instance.
        this._onKeyboardShortcutEnableChanged = this._onKeyboardShortcutEnableChanged.bind(this);
        this._renderShortcutsListItem = this._renderShortcutsListItem.bind(this);
    }
    /**
     * Callback invoked to select if global keyboard shortcuts
     * should be enabled.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onKeyboardShortcutEnableChanged({ target: { checked } }) {
        super._onChange({ keyboardShortcutsEnabled: checked });
    }
    /**
     * Render a keyboard shortcut with key and description.
     *
     * @param {string} keyboardKey - The keyboard key for the shortcut.
     * @param {string} translationKey - The translation key for the shortcut description.
     * @returns {JSX}
     */
    _renderShortcutsListItem(keyboardKey, translationKey) {
        const { t } = this.props;
        const classes = withStyles.getClasses(this.props);
        let modifierKey = 'Alt';
        if (window.navigator?.platform) {
            if (window.navigator.platform.indexOf('Mac') !== -1) {
                modifierKey = '⌥';
            }
        }
        // не отображаем кириллические буквы
        if (['А', 'Ь', 'М', 'С', 'В', 'З', 'К', 'Ы', 'Ц', 'Е'].includes(keyboardKey)) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("li", { className: classes.listItem, key: keyboardKey },
            React.createElement("span", { className: classes.listItemKey }, keyboardKey.startsWith(':')
                ? `${modifierKey} + ${keyboardKey.slice(1)}`
                : keyboardKey),
            React.createElement("span", { "aria-label": t(translationKey) }, t(translationKey))));
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { displayShortcuts, keyboardShortcutsHelpDescriptions, keyboardShortcutsEnabled, t } = this.props;
        const classes = withStyles.getClasses(this.props);
        // порядок ключей
        const order = ['m', 'v', 'c', 'd', 'p', 'r', 's', 'w', 't', '0', '1-9', 'space'];
        // сортировка
        const compareFunction = (a, b) => {
            const keyA = a[0].toLowerCase(); // keyboardKey
            const keyB = b[0].toLowerCase(); // translationKey
            const indexA = order.indexOf(keyA);
            const indexB = order.indexOf(keyB);
            // Если ключ не найден в order, он будет помещен в конец
            const positionA = indexA === -1 ? order.length : indexA;
            const positionB = indexB === -1 ? order.length : indexB;
            return positionA - positionB;
        };
        const shortcutDescriptions = displayShortcuts
            ? keyboardShortcutsHelpDescriptions
            : new Map();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.container }, displayShortcuts && (React.createElement("ul", { className: classes.listContainer }, Array.from(shortcutDescriptions)
                .sort(compareFunction)
                .map(description => this._renderShortcutsListItem(...description))))),
            React.createElement("div", { className: classes.checkboxContainer },
                React.createElement(Checkbox, { checked: keyboardShortcutsEnabled, className: classes.checkbox, classNameText: classes.checkboxText, label: t('prejoin.keyboardShortcuts'), name: 'enable-keyboard-shortcuts', onChange: this._onKeyboardShortcutEnableChanged }))));
    }
}
export default withStyles(translate(ShortcutsTab), styles);
